import { render, staticRenderFns } from "./CourtDillonvale.vue?vue&type=template&id=31fa7444&scoped=true&"
import script from "./CourtDillonvale.vue?vue&type=script&lang=js&"
export * from "./CourtDillonvale.vue?vue&type=script&lang=js&"
import style0 from "./CourtDillonvale.vue?vue&type=style&index=0&id=31fa7444&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fa7444",
  null
  
)

export default component.exports